import React from 'react';
import './ChecklistProgressBar.scss';
import { useTranslation } from 'react-i18next';
import { ProgressBar } from 'primereact/progressbar';

interface ChecklistProgressBarProps {
  checked: number;
  total: number;
  percent: number;
}

const ChecklistProgressBar: React.FC<ChecklistProgressBarProps> = ({ checked, total, percent }) => {
  const { t } = useTranslation();

  return (
    <div className="checklist-progress">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">
          {t('geoChecklist.progress')}
        </div>
        <span className="checklist-badge">
          {checked}/{total} ({percent}%)
        </span>
      </div>
      <div className="checklist-card checklist-progress__bar-box">
        <ProgressBar value={percent} showValue={false} />
      </div>
    </div>
  );
};

export { ChecklistProgressBar };
export default ChecklistProgressBar;
